import capitalize from 'lodash/capitalize';

const VERSION_REGEX = /((dev|beta|[0-9]+)\.?)+/g;

export const parseVersion = (value) => {
  const match = value.match(VERSION_REGEX);

  if (!value || !match) {
    return undefined;
  }

  return match[0];
};

export const parseName = (value) => {
  const fragments = value.split(' ');
  const version = parseVersion(value);

  const output = {
    fragments,
    version,
  };

  if (!fragments.length || !fragments[0]) {
    // handle empty title
    output.parsed = 'unknown';
    return output;
  }

  if (fragments.length === 1 && fragments[0].length > 0) {
    // split into fragments but it's a single value; for example "Linux"
    output.parsed = fragments[0];
    return output;
  }

  if (!version) {
    // version could not be parsed; assume the name has no version included
    output.parsed = fragments.join(' ');
    return output;
  }

  // otherwise, it successfully split the string into name and version
  output.parsed = fragments.slice(0, -1).join(' ');
  return output;
};

export const getOSName = (title) => {
  const { fragments, parsed } = parseName(title);

  if (fragments[0] === 'macOS' || fragments[0] === 'OS') {
    // handle macOS both old and new conventions
    return 'macOS';
  }

  return parsed;
};

export const getBrowserName = (title) => {
  const { parsed } = parseName(title);

  return parsed;
};

export const getDeviceName = (title) => {
  if (title === 'desktop') {
    return capitalize(title);
  }

  return title;
};

export const getFrameworkName = (title) => {
  const { parsed } = parseName(title);

  return capitalize(parsed);
};
